export class InputCheckbox {
    public value: boolean = false;
    public error: string = "";

}